import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PrButtonComponent } from './pr-button.component';
import { PrIconModule } from '@app/components/pr-icon/pr-icon.module';

@NgModule({
  imports: [CommonModule, PrIconModule],
  exports: [PrButtonComponent],
  declarations: [PrButtonComponent],
})
export class PrButtonModule {}
